/* Custom Hooks */
import useForm from "./hooks/useForm";
import { validateField, validateEmail } from "./hooks/useValidation";

import React from "react";

/* Styles */
import "./css/stylesUTH.css";
import Inversa from "./images/Inversa2.png";

const Form = () => {
  /*
		values: obtiene el estado actual de los valores del formulario
		setField: cambia el estado de los valores del formulario, recibe dos argumentos: el campo (propiedades de initialValues) y su valor,
		errors: obtiene los errores del formulario,
		handleSubmit: función que se pasa al onSubmit del formulario para validarlo
	*/

  const handleSubmitForm = (event) => {
    event.preventDefault();
    const emailDomain = event.target.email.value.split("@")[1];

    if (emailDomain === "uth.hn") {
      var formdata = new FormData();
      formdata.append("usr", "uth_academic");
      formdata.append("pwd", "1");
      formdata.append("Email", event.target.email.value);

      var requestOptions = {
        method: "POST",
        Headers: { "Access-Control-Allow-Origin": "*" },
        body: formdata
      };

      fetch('https://uthacademic.uth.hn:8078/soporte/soporte.php', requestOptions)
      .then(response => response.json())
      .then(data => {
        const resp = data.response[0].Cantidad;
        handleSubmit(event, resp)
        
      })
      .catch(error => {
        console.error('Error:', error);
      });
    } else {
      handleSubmit(event);
    }
  }


  const { values, setFieldValue, errors, handleSubmit } = useForm({
    /* Valores iniciales del formulario */
    initialValues: {
      name: "",
      email: "",
    },

    // validationSchema: validateFormSchema,
    // validateAllFields: true,
    validate: (property, value) => {
      /* Si VALIDATE_ALL_FIELDS es false VALIDATE recibe 2 parámetros: la propiedad y su valor, dependiendo de su propiedad se va a cumplir la regla, si es true, recibe un obj que es el estado de los valores */
      /* Crea un obj vacío fuera de la función validate (línea 32), a continuación crea las reglas y añade propiedades al obj que serán los errores para mostrarlos como errorObj.name = 'Campo obligatorio'. Retorna los errores para validarlos */
      /* ADVERTENCIA: Si usted a proporciona validateAllFields en TRUE y añade dos argumentos en validate, no funcionará la validación, cuando validateAllFields es false recibe dos parametros y cuando es true sólo uno */

      /* Ejemplo de validación en cada campo individualmente */
      const errorObj = {};      

      switch (property) {
        case "name":
          const testName = validateField({
            name: property,
            value,
            required: "Nombre es requerido.",
            max: 100,
            min: 5,
            shortValue:
              "Se ha excedido el limite de carácteres en este campo (Máximo 100). Favor ingresar el nombre con menos caracteres.",
            validField: "Error, Favor ingresar solo caracteres alfabeticos.",
          });
          Object.assign(errorObj, testName);
          break;
        case "email":
          /* VERIFICA EL HOOK useValidation y su función validateEmail */
          const testEmail = validateEmail({
            value,
            required: "Correo electrónico es requerido.",
            max: 50,
            validEmail: "Correo electrónico no válido.",
            validDns: "Error, cuenta de correo no autorizada.",
            shortValue:
              "Se ha excedido el limite de caracteres en este campo (Máximo 50). Favor ingresar el email con menos caracteres.",
          });
          Object.assign(errorObj, testEmail);
          break;
      }
      return errorObj;
    },
    onSubmit: ({ values, resetForm }) => {},
  });

  return (
    // Formulario principal
    <form
      id="principal"
      className="form-control shadow-lg "
      onSubmit={handleSubmitForm}
    >
      {/* Logo de la empresa */}
      <div className="imagen">
        <img id="img-principal" src={Inversa} width="52%" />
      </div>
      {/* Contenedor de Formulario */}
      <div className="col-sm-12">
        <p className="fst-normal fs-4 text-center">Portal de Soporte</p>
        {/* Campo Nombre con sus validaciones, mensaje de error e icono */}
        <div className="row mb-3">
          <div className="input-group">
            <span className="input-group-text">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-person-fill"
                viewBox="0 0 16 16"
              >
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
              </svg>
            </span>
            <input
              type="text"
              value={values.name}
              id="name"
              name="name"
              placeholder="Nombre"
              className="fuente form-control"
              // autoComplete='off'
              autoFocus
              onChange={(e) => setFieldValue("name", e.target.value)}
            />
          </div>
          <div className="text-danger">{errors.name}</div>
        </div>
        {/* Campo Correo Electrónico con sus validaciones, mensaje de error e icono */}
        <div className="row mb-3">
          <div className="input-group">
            <span className="input-group-text">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-envelope"
                viewBox="0 0 16 16"
              >
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
              </svg>
            </span>
            <input
              type="email"
              value={values.email}
              id="email"
              name="email"
              placeholder="Correo Electrónico"
              className="fuente form-control"
              // autoComplete='off'
              onChange={(e) => setFieldValue("email", e.target.value)}
            />
          </div>
          <div className="text-danger">{errors.email}</div>
        </div>

        {/* Botón para continuar al siguiente formulario */}
        <div className="fuente d-grid gap-2 col-4 mx-auto">
          <button
            className="btn btn-secondary shadow text-center mt-3 mb-2"
            type="submit"
            id="submitButton"
            disabled
          >
            Siguiente
          </button>
        </div>
      </div>
    </form>
  );
};

export default Form;
